import axios from "axios";
import { CUSTOMER_API_BASE, CUSTOMER_ADMIN_API_BASE } from "../env";

export async function getCustomerDocuments(customerId, signed, token) {
  return axios.get(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/documents`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        signed,
      },
    },
  );
}

export async function getCustomerDocumentsByType(customerId, type, facility, token) {
  return axios.get(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/documents`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        type,
        facility,
      },
    },
  );
}

export async function getExpiredInsurances(customerId, facility, token) {
  return axios.get(
    `${CUSTOMER_ADMIN_API_BASE}/${customerId}/archived/insurances`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        facility,
      },
    }
  );
}

export async function deleteCustomerPurgedDocuments(customerId, facilityId, token) {
  return axios.delete(
    `${CUSTOMER_ADMIN_API_BASE}/${customerId}/${facilityId}/remove/purged-documents`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export async function createCustomerDocument(customerId, body, signed, token) {
  return axios.post(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/documents`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        ...(signed ? { signed } : {}),
      },
    },
  );
}

export async function updateCustomerDocument(
  customerId,
  documentId,
  body,
  signed,
  token,
) {
  return axios.put(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/documents/${documentId}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        ...(signed ? { signed } : {}),
      },
    },
  );
}

export async function deleteCustomerDocument(
  customerId,
  documentId,
  signed,
  authToken,
) {
  return axios.delete(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/documents/${documentId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: {
        ...(signed ? { signed } : {}),
      },
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/documents.js